import { useEffect } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'

import { MonomerErrorBoundary } from '~/components/MonomerErrorBoundary'
import { MultiFrontendContext } from '~/core/MultiFrontendContext'
import DatasetPage from './DatasetPage/DatasetPage'
import DatasetsList from './DatasetsList'
import cs from './dataset_routes.scss'
import MissedDatasetsPage from './MissedDatasetsPage/MissedDatasetsPage'

const DatasetRoutes = ({
  frontendContext,
}: {
  frontendContext: MultiFrontendContext
}) => {
  const match = useRouteMatch()

  useEffect(() => {
    if (frontendContext.deploymentMode !== 'on_prem_agent') {
      window.location.href = `${frontendContext.cloudFrontend}`
    }
  }, [frontendContext])
  if (frontendContext.deploymentMode !== 'on_prem_agent') {
    return <div className={cs.routeErrorContainer}>Redirecting...</div>
  }

  return (
    <MonomerErrorBoundary>
      <div className={cs.datasetRoutes}>
        <Switch>
          <Route exact path={match.path} render={() => <DatasetsList />} />
          <Route
            exact
            path={`${match.path}/missed`}
            render={() => <MissedDatasetsPage />}
          />
          <Route
            exact
            path={`${match.path}/:datasetUuid`}
            render={({
              match: {
                params: { datasetUuid },
              },
            }) => <DatasetPage datasetUuid={datasetUuid} />}
          />
        </Switch>
      </div>
    </MonomerErrorBoundary>
  )
}

export default DatasetRoutes
